import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api';

export const CLIENTMANAGER_REQUEST = 'CLIENTMANAGER_REQUEST';
export const CLIENTMANAGER_SUCCESS = 'CLIENTMANAGER_SUCCESS';
export const CLIENTMANAGER_FAILURE = 'CLIENTMANAGER_FAILURE';

export const CLIENT_REQUEST = 'CLIENT_REQUEST';
export const CLIENT_SUCCESS = 'CLIENT_SUCCESS';
export const CLIENT_FAILURE = 'CLIENT_FAILURE';

export const CLIENT_UPDATE_REQUEST = 'CLIENT_UPDATE_REQUEST';
export const CLIENT_UPDATE_SUCCESS = 'CLIENT_UPDATE_SUCCESS';
export const CLIENT_UPDATE_FAILURE = 'CLIENT_UPDATE_FAILURE';

export const CLIENTS_TYPEAHEAD_REQUEST = 'CLIENTS_TYPEAHEAD_REQUEST';
export const CLIENTS_TYPEAHEAD_SUCCESS = 'CLIENTS_TYPEAHEAD_SUCCESS';
export const CLIENTS_TYPEAHEAD_FAILURE = 'CLIENTS_TYPEAHEAD_FAILURE';

export const CLIENT_GET_FILES_REQUEST = 'CLIENT_GET_FILES_REQUEST';
export const CLIENT_GET_FILES_SUCCESS = 'CLIENT_GET_FILES_SUCCESS';
export const CLIENT_GET_FILES_FAILURE = 'CLIENT_GET_FILES_FAILURE';

export const CLIENT_UPLOAD_FILES_REQUEST = 'CLIENT_UPLOAD_FILES_REQUEST';
export const CLIENT_UPLOAD_FILES_SUCCESS = 'CLIENT_UPLOAD_FILES_SUCCESS';
export const CLIENT_UPLOAD_FILES_FAILURE = 'CLIENT_UPLOAD_FILES_FAILURE';

export const CLIENT_GET_FILE_REQUEST = 'CLIENT_GET_FILE_REQUEST';
export const CLIENT_GET_FILE_SUCCESS = 'CLIENT_GET_FILE_SUCCESS';
export const CLIENT_GET_FILE_FAILURE = 'CLIENT_GET_FILE_FAILURE';

export const CLIENT_PREVIEW_FILE_REQUEST = 'CLIENT_PREVIEW_FILE_REQUEST';
export const CLIENT_PREVIEW_FILE_SUCCESS = 'CLIENT_PREVIEW_FILE_SUCCESS';
export const CLIENT_PREVIEW_FILE_FAILURE = 'CLIENT_PREVIEW_FILE_FAILURE';

export const CLIENT_UPDATE_FILE_REQUEST = 'CLIENT_UPDATE_FILE_REQUEST';
export const CLIENT_UPDATE_FILE_SUCCESS = 'CLIENT_UPDATE_FILE_SUCCESS';
export const CLIENT_UPDATE_FILE_FAILURE = 'CLIENT_UPDATE_FILE_FAILURE';

export const CLIENT_DELETE_FILE_REQUEST = 'CLIENT_DELETE_FILE_REQUEST';
export const CLIENT_DELETE_FILE_SUCCESS = 'CLIENT_DELETE_FILE_SUCCESS';
export const CLIENT_DELETE_FILE_FAILURE = 'CLIENT_DELETE_FILE_FAILURE';

export const CLIENT_REPORT_CATEGORIES_REQUEST = 'CLIENT_REPORT_CATEGORIES_REQUEST';
export const CLIENT_REPORT_CATEGORIES_SUCCESS = 'CLIENT_REPORT_CATEGORIES_SUCCESS';
export const CLIENT_REPORT_CATEGORIES_FAILURE = 'CLIENT_REPORT_CATEGORIES_FAILURE';

export const CLIENT_TPA_SUBGROUPS_REQUEST = 'CLIENT_TPA_SUBGROUPS_REQUEST';
export const CLIENT_TPA_SUBGROUPS_SUCCESS = 'CLIENT_TPA_SUBGROUPS_SUCCESS';
export const CLIENT_TPA_SUBGROUPS_FAILURE = 'CLIENT_TPA_SUBGROUPS_FAILURE';

export function requestClients(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clients/search?${query}`,
      method: 'GET',
      types: ['CLIENTMANAGER_REQUEST', 'CLIENTMANAGER_SUCCESS', 'CLIENTMANAGER_FAILURE']
    }
  };
}

export function requestClient(employerCodeNumber, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/client-matrix/${employerCodeNumber}?${query}`,
      method: 'GET',
      types: ["CLIENT_REQUEST", "CLIENT_SUCCESS", "CLIENT_FAILURE"]
    }
  }
}

export function updateClient(client, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/client-matrix/${client.employerCodeNumber}?${query}`,
      method: 'POST',
      body: JSON.stringify(client),
      types: ["CLIENT_UPDATE_REQUEST", "CLIENT_UPDATE_SUCCESS", "CLIENT_UPDATE_FAILURE"]
    }
  }
}

export function requestClientsTypeahead(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clients/typeahead?${query}`,
      method: 'GET',
      types: ['CLIENTS_TYPEAHEAD_REQUEST', 'CLIENTS_TYPEAHEAD_SUCCESS', 'CLIENTS_TYPEAHEAD_FAILURE']
    }
  };
}


export function requestClientFiles(clientCode, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clients/${clientCode}/files?${query}`,
      method: 'GET',
      types: [
        { type: 'CLIENT_GET_FILES_REQUEST', meta: { clientCode } },
        { type: 'CLIENT_GET_FILES_SUCCESS', meta: { clientCode } },
        { type: 'CLIENT_GET_FILES_FAILURE', meta: { clientCode } },
      ]
    }
  };
}

export function uploadClientFiles(clientCode, params, htmlFiles = []) {
  const query = $.param(params);
  const data = new FormData();

  htmlFiles.forEach((file) => data.append('files', file));

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clients/${clientCode}/files?${query}`,
      method: 'POST',
      headers: {},
      body: data,
      types: ['CLIENT_UPLOAD_FILES_REQUEST', 'CLIENT_UPLOAD_FILES_SUCCESS', 'CLIENT_UPLOAD_FILES_FAILURE']
    },
  };
}

export function getClientFile(clientCode, params, fileName) {
  const query = $.param(params);

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clients/${clientCode}/files/${fileName}/?${query}`,
      method: 'GET',
      headers: {},
      types: [
        'CLIENT_GET_FILE_REQUEST',
        {
          type: 'CLIENT_GET_FILE_SUCCESS',
          payload: (action, state, res) => {
            return res.blob();
          }
        },
        'CLIENT_GET_FILE_FAILURE']
    },
  };
}

export function previewFile(clientCode, params, fileName) {
  const query = $.param(params);

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clients/preview/${clientCode}/files/${fileName}/?${query}`,
      method: 'GET',
      headers: {},
      types: [
        'CLIENT_PREVIEW_FILE_REQUEST',
        {
          type: 'CLIENT_PREVIEW_FILE_SUCCESS',
          payload: (action, state, res) => {
            return res.blob();
          },
        },
        'CLIENT_PREVIEW_FILE_FAILURE']
    }
  };
}

export function updateClientFileDescription(clientCode, fileName, params, data) {
  const query = $.param(params);

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clients/${clientCode}/files/${fileName}/description?${query}`,
      method: 'POST',
      body: JSON.stringify(data),
      types: ['CLIENT_UPDATE_FILE_REQUEST', 'CLIENT_UPDATE_FILE_SUCCESS', 'CLIENT_UPDATE_FILE_FAILURE']
    },
  };
}

export function deleteClientFile(clientCode, params, fileName) {
  const query = $.param(params);

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clients/${clientCode}/files/${fileName}/?${query}`,
      method: 'DELETE',
      types: ['CLIENT_DELETE_FILE_REQUEST', 'CLIENT_DELETE_FILE_SUCCESS', 'CLIENT_DELETE_FILE_FAILURE']
    },
  };
}

export function requestClientReportCategories(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/lookups/client-report-categories/all?${query}`,
      method: 'GET',
      types: ['CLIENT_REPORT_CATEGORIES_REQUEST', 'CLIENT_REPORT_CATEGORIES_SUCCESS', 'CLIENT_REPORT_CATEGORIES_FAILURE']
    },
  };
}
export function requestClientTPASubgroups(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/lookups/client-tpa-subgroups/all?${query}`,
      method: 'GET',
      types: ['CLIENT_TPA_SUBGROUPS_REQUEST', 'CLIENT_TPA_SUBGROUPS_SUCCESS', 'CLIENT_TPA_SUBGROUPS_FAILURE']
    },
  };
}



// WEBPACK FOOTER //
// ./src/store/client-manager/ClientManagerActions.js